<template>
  <div class="welcome">

    <div style="position:absolute;width:1px;height:1px;">
      <div class="logobackground">
        <img src="@/assets/logocorner.png" style="opacity: 0.5;">
      </div>
    </div>
    <div class="futuretown" style="margin: auto;padding:10px;z-index:1100">
        <span style="color: var(--sl-purple)">Explore Together</span><span style="color: gray"> @ </span><span style="color: var(--sl-red)">Future</span><span style="color: var(--sl-blue)">Town</span>
    </div>
      
    <div class="mainWrapper">
        <div class="headline headline1st">
                Nu er det officielt - Futuretown 2.6 på Spejdernes Lejr 2026
        </div>

        <div class="flex">
          <div class="textColumn">
              <div class="tekst">
                Vil du være med til at:<br>
                <li>planlægge en aktivitet i FutureTown</li>
                <li>hjælpe på en aktivitet i FutureTown</li>
                <li>hjælpe på noget af en aktivitet i FutureTown</li>
                <li>Stå i caféen i FutureTown</li>
                <br>..eller blot være informeret ... om FutureTown<br><br>
                Så meld dig til vores mailliste her: <br><br>
                <a href="https://jobs.spejderneslejr.dk" target="_blank" style="margin:auto">
                <button class="button red" @click="">Meld dig som frivillig...</button></a> (Søg efter Futuretown, i joblisten)<br><br>
                Eller - hvis du blot ønsker information, skriv til Mads (mads.hjortkjaer@sl2026.dk)
              </div>
          </div>
          <div class="imageColumn">
              <img src="@/assets/frivillig.png" class="imageSizing">
          </div>
        </div>
        
        <div class="headline headline2nd" v-if="false">
               Idé-Webinar 25. juni 2025 kl. 19.30-20.30
        </div>
     
        <div class="flex" v-if="false">
          <div class="textColumn">
              <div class="tekst">
                  <li>Er du kreativ?</li>
                  <li>Har gode idéer til spejderaktiviteter?</li>
                  <li>Brænder du for at bidrage til en uforglemmelig oplevelse for alle?</li>
                  <br>
                  Så deltag i vores webinar, hvor vi indsamler spændende idéer til FutureTown!<br><br>
                  <b>25. juni 2025 kl. 19.30-20.30</b>
                  <a href="https://forms.gle/CnbUeHB9ECKGnD8W9" target="_blank" style="margin:auto auto auto 20px" >
                        <button class="button red" @click="">Meld dig til webinaret her...</button>
                  </a><br><br><hr>
                  <b>Mødes afholdes her - du kan deltage uden tilmelding.</b><br><br>
                  <a href="https://meet.google.com/yoy-jqta-gwh" target="_blank" style="margin:auto auto auto 20px" >
                        <button class="button green" @click="">Deltag i GoogleMeet her.</button>
                  </a>
                  <br><br>
                  Eller: <a href="https://meet.google.com/yoy-jqta-gwh"><b>meet.google.com/yoy-jqta-gwh</b></a><br>
                  <br>
                  Eller via telefon: (DK) +45 70 71 47 24 - Pinkode: 353 307 843#<br>
                  
                  <br><br>
                  

              </div>
          </div>
          <div class="imageColumn">
              <img src="@/assets/Webinar-900x900-transp.png" class="imageSizing">
          </div>
      </div>
    </div>
      <div class="footer">
        <div style="margin-right:20px">
          Følg også med på <a style="color:white;text-decoration: none;" href="https://www.facebook.com/groups/984849582147290/" target="_blank">
            <img src="@/assets/facebook.png" style="vertical-align:middle;width: 40px;margin: 10px;">Facebook</a>
          <a style="color:white;text-decoration: none;" href="https://instagram.com/futuretown26" target="_blank">
            <img src="@/assets/Instagram.png" style="vertical-align:middle;width: 40px;margin: 10px;">Instagram</a>
        </div>
      </div>

      <div class="lejrfrivillig">
        Vil du være Lejrfrivillig?
      </div>
  </div>
  
</template>

<style scoped>
.welcome {
  height: 100%;
  width: 100%;
  padding: 0px;
  
}

.futuretown {
  position: relative;
  font-family: Countless;
  font-size: 80px;
  
}

.mainWrapper {
  width: 90%;
  margin: 50px auto auto auto;
  background-color:var(--sl-green);
}
.wrapper {
  display: flex;
}
.flex {
  display: flex;
}
.textColumn {
  
    width: calc(100% - 324px);
    background-color:white;
}
.imageColumn {
    width: 324px;
    background-color: var(--sl-green);
    align-items: right;
}
.imageSizing {
    width: 100%;
}
.tekst {
  width: calc(100% - 15px);
  padding: 15px 0px 15px 25px;
  overflow: none;
}

.headline {
  margin: 0px 0px auto 0px;
  padding: 10px;
  font-size: 19px;
  background-color: var(--sl-red);
  color: white;
  font-weight: bold; 
}

.headline1st {
  width: calc(100% - 20px)
}

.headline2nd {
  width: calc(100% - 324px);
}

.footer {
  max-width: 90%;
  background-color: var(--sl-red);
  height: 60px;
  margin: 0px auto auto auto;
  color: white;
  text-align: right;
}

.lejrfrivillig {
  margin:30px auto auto auto;font-size: 30px;text-align: center;
}

@media screen and (max-width: 1000px) {
  .imageColumn   { width:300px; } 
  .textColumn    { width: calc(100% - 300px) } 
  .headline2nd   { width: calc(100% - 300px) }
}

@media screen and (max-width: 760px) {
  .futuretown     { font-size: 60px; }    
  .logobackground img { height: 100px; }
  .mainWrapper    { margin-top: 0px  }
  .imageColumn    { width: 200px; } 
  .headline2nd    { width: calc(100% - 200px) }
  .textColumn     { width: calc(100% - 200px) }
  
}

@media screen and (max-width: 615px) {
  .futuretown { font-size: 40px; }    
  .logobackground img { height: 70px; }
  .headline {font-size: 18px; }
  .imageColumn    { width: 150px; } 
  .headline2nd    { width: calc(100% - 150px) }
  .textColumn     { width: calc(100% - 150px) }
  
}

@media screen and (max-width: 510px) {
  .futuretown { font-size: 35px; }    
  .logobackground img { height: 70px; }
  .headline {font-size: 15px; }
  .imageColumn    { width: 100px; } 
  .headline2nd    { width: calc(100% - 100px) }
  .textColumn     { width: calc(100% - 100px) }
  
}

@media screen and (max-width: 400px) {
  .headline {font-size: 12px; }
  .futuretown { font-size: 25px; }    
  .imageColumn    { width: 100px; } 
  .headline2nd    { width: calc(100% - 100px) }
  .textColumn     { width: calc(100% - 100px) ;font-size: 13px;}
  
  
}

</style>
